import { Option } from 'components/common/types/DropdownItem.types';
import { VenueTaxonomyResponse } from './VenueTaxonomy.types';

const mapVenueTaxonomyToMultiLevelData = (data: VenueTaxonomyResponse[]): Option[] =>
  data.map((item) => {
    const children = item.children?.length
      ? item.children.map((child) => {
          const grandChildren = child.grandChildren?.length
            ? child.grandChildren.map((grandChild) => ({
                code: grandChild.enumerationId,
                name: grandChild.categoryCode,
                selectable: grandChild.selectable,
                parentCode: child.enumerationId,
              }))
            : undefined;

          return {
            children: grandChildren,
            code: child.enumerationId,
            name: child.categoryCode,
            selectable: child.selectable,
          };
        })
      : undefined;

    return {
      children,
      code: item.enumerationId,
      name: item.categoryCode,
      selectable: item.selectable,
    };
  });

export { mapVenueTaxonomyToMultiLevelData };
